<app-backgrop class="relative z-100">
  <div class="px-6 sm:px-0 max-w-full">
    <app-dialog class="flex max-w-full w-[650px] sm:landscape:max-w-150 p-2">

      <div class="flex flex-col items-center mb-4">
        <app-title class="text-(--custom-color-1)">Уровень понимания</app-title>
      </div>
      <app-text-simple class="text-(--custom-color-1) text-center block w-full md:w-[366px] m-auto mb-4 md:mb-5">Оцени по шкале от 1го до 10ти.<br>Насколько хорошо ты сейчас понимаешь какую выбрать профессию?</app-text-simple>
      <div class="flex justify-between w-full">
        <app-text-simple-smaller class="text-(--custom-color-1)/50">Не понимаю</app-text-simple-smaller>
        <app-text-simple-smaller class="text-(--custom-color-5)">Понимаю</app-text-simple-smaller>
      </div>
      <div class="w-full h-[3px] bg-[linear-gradient(to_right,_rgba(168,197,0,0),_#A8C500)] mb-4"></div>
      <div class="flex justify-between">
        @for (item of [1,2,3,4,5,6,7,8,9,10]; track $index) {
          @if (selectedValue === item) {
            <div class="size-[25px] sm:size-12 flex items-center justify-center rounded-full bg-(--custom-color-6) outline-2 outline-(--custom-color-6)">
              <div
                class="shadow-(--custom-bottom-shadow2sm) sm:shadow-(--custom-bottom-shadow2) border rounded-full border-black text-xs sm:text-lg/5 font-black flex justify-center items-center cursor-pointer bg-(--main-color) text-white size-[19px] sm:size-8"
                (click)="selectValue(item)"
              >
                {{ item }}
              </div>
            </div>
          } @else {
            <div
              class=" border rounded-full border-(--custom-color-6) text-xs sm:text-lg/5 font-black flex justify-center items-center cursor-pointer transition-all duration-300 ease-in-out hover:bg-(--main-color) hover:text-white size-[25px] sm:size-12 bg-white text-black/50"
              (click)="selectValue(item)"
            >
              {{ item }}
            </div>
          }
        }
      </div>
      
      <div class="flex justify-center mt-4 md:mt-8 -mb-3 sm:mb-unset">
        <app-button class="md:scale-unset" [disabledColor]="'black'" [disabled]="!selectedValue" (clicked)="apply()">
          Продолжить
        </app-button>
      </div>
    </app-dialog>

  </div>
</app-backgrop>